export default {"src":"/_next/static/media/DXC.52b478d5.svg","height":136,"width":249,"blurWidth":0,"blurHeight":0};